const FIRE_CAUSES = {
    1: "Lightning",
    2: "Equipment Use",
    3: "Smoking",
    4: "Campfire",
    5: "Debris",
    6: "Railroad",
    7: "Arson",
    8: "Playing with fire",
    9: "Miscellaneous",
    10: "Vehicle",
    11: "Powerline",
    12: "Firefighter Training",
    13: "Non-Firefighter Training",
    14: "Unknown",
    15: "Structure",
    16: "Aircraft",
    17: "Unknown",
    18: "Escaped Prescribed Burn",
    19: "Campfire",
  }

export default FIRE_CAUSES